<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.couriers'), $t('text.list')]">
        <el-button type="success" size="mini" @click="add"
          >+ {{ $t("text.create") }}</el-button
        >

        <el-button
          type="primary"
          size="mini"
          @click="addLianbang"
          v-if="showLianBangCompute()"
        >
          {{ $t("action.lianbang") }}
        </el-button>
      </breadcrumb>
    </div>

    <div class="wrapper table-area">
      <vxe-table
        :data="courierTenants"
        :loading="loading"
        id="phaseGroupTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="courier.name"
          :title="$t('text.name')"
          min-width="100"
        />
        <vxe-table-column
          field="courier.login"
          :title="$t('courier.login')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.courier.login }}
            <div
              v-if="row.courier.login == 'dhl' && row.dpsProd == true"
              class="font10 green"
            >
              已开通正式申报
            </div>
            <div>
              <el-popover
                placement="right"
                width="600"
                trigger="click"
                v-if="row.economyServiceJson != null"
              >
                <div class="lineH24">
                  {{ $t("courier.warehouse_name") }}：{{
                    JSON.parse(row.economyServiceJson).warehouse_name
                  }}
                </div>
                <div class="lineH24">
                  {{ $t("courier.logistics_service_name") }}：{{
                    JSON.parse(row.economyServiceJson).logistics_service_name
                  }}
                </div>
                <div class="lineH24">
                  {{ $t("courier.delivery_address") }}：
                  {{ JSON.parse(row.economyServiceJson).delivery_address }}
                </div>

                <span slot="reference" class="popover-reference orange mgr10">
                  经济
                </span>
              </el-popover>
              <el-popover
                placement="right"
                width="600"
                trigger="click"
                v-if="row.standardServiceJson != null"
              >
                <div class="lineH24">
                  {{ $t("courier.warehouse_name") }}：{{
                    JSON.parse(row.standardServiceJson).warehouse_name
                  }}
                </div>
                <div class="lineH24">
                  {{ $t("courier.logistics_service_name") }}：{{
                    JSON.parse(row.standardServiceJson).logistics_service_name
                  }}
                </div>
                <div class="lineH24">
                  {{ $t("courier.delivery_address") }}：{{
                    JSON.parse(row.standardServiceJson).delivery_address
                  }}
                </div>

                <span slot="reference" class="popover-reference orange mgr10">
                  标准
                </span>
              </el-popover>
              <el-popover
                placement="right"
                width="600"
                trigger="click"
                v-if="row.premiumServiceJson != null"
              >
                <div class="lineH24">
                  {{ $t("courier.warehouse_name") }}：{{
                    JSON.parse(row.premiumServiceJson).warehouse_name
                  }}
                </div>
                <div class="lineH24">
                  {{ $t("courier.logistics_service_name") }}：{{
                    JSON.parse(row.premiumServiceJson).logistics_service_name
                  }}
                </div>
                <div class="lineH24">
                  {{ $t("courier.delivery_address") }}：{{
                    JSON.parse(row.premiumServiceJson).delivery_address
                  }}
                </div>

                <span slot="reference" class="popover-reference orange mgr10">
                  优先
                </span>
              </el-popover>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="courier.contact"
          :title="$t('courier.contact')"
          min-width="100"
        />
        <vxe-table-column
          field="courier.phone"
          :title="$t('courier.phone')"
          min-width="100"
        />
        <vxe-table-column
          field="printPck"
          :title="$t('action.printPck')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <span v-if="row.printPick != null">{{
              $t("boolean." + row.printPick)
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="type"
          :title="$t('action.integration')"
          min-width="50"
        >
          <template v-slot="{ row }">
            <span
              v-if="
                row.erpKey != null &&
                row.erpPassword != null &&
                row.erpKey != '' &&
                row.erpPassword != ''
              "
              >{{ $t("boolean.true") }}</span
            >
            <span v-else>{{ $t("boolean.false") }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="action" :title="$t('text.action')" width="160">
          <template v-slot="{ row }">
            <el-button type="text" size="mini" @click="deliverMethod(row)">{{
              $t("action.deliverMethods")
            }}</el-button>
            <el-button type="text" size="mini" @click="deleteRow(row)">{{
              $t("text.delete")
            }}</el-button>
            <div v-if="row.courier.login == 'sumaitong'">
              <el-button type="text" size="mini" @click="editSumaitong(row)">{{
                $t("text.edit")
              }}</el-button>
            </div>
            <div v-if="row.courier.login == 'youzhengguanfang'">
              <el-button type="text" size="mini" @click="editYouzheng(row)">{{
                $t("text.edit")
              }}</el-button>
            </div>
            <div>
              <el-button type="text" size="mini" @click="integration(row)">{{
                $t("action.integration")
              }}</el-button>
              <el-button
                v-if="row.printPick"
                type="text"
                size="mini"
                @click="cancelPrintPck(row)"
                >{{ $t("action.cancelPrintPck") }}</el-button
              >
              <el-button
                v-if="!row.printPick"
                type="text"
                size="mini"
                @click="printPck(row)"
                >{{ $t("action.printPck") }}</el-button
              >
            </div>
            <div v-if="row.courier.login == 'dhl'">
              <el-button type="text" size="mini" @click="dhlDpsProd(row)">{{
                $t("action.dhlDpsProd")
              }}</el-button>
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <!-- 新增国际快递 -->
    <el-dialog
      :title="$t('text.create')"
      :visible.sync="addDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form ref="addObjForm" :model="addObj">
        <el-form-item
          :prop="'courierId'"
          :rules="[
            {
              required: true,
              validator: validateCourierId,
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="addObj.courierId"
            clearable
            filterable
          >
            <el-option-group
              v-for="group in couriersSelect"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="courier in group.options"
                :key="courier.id"
                :label="courier.name"
                :value="courier.id"
              >
                <span style="float: left">{{ courier.name }}</span>
                <span
                  style="float: right; color: #8492a6; font-size: 13px"
                  v-if="group.label == '简赢对接'"
                  >{{ courier.phone }}</span
                >
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="addDoing"
          size="small"
          @click="addSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('action.deliverMethods')"
      :close-on-click-modal="false"
      :visible.sync="deliverMethodDF"
      width="50%"
    >
      <vxe-table
        :data="deliverMethods"
        id="deliverMethodTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        highlight-hover-row
        auto-resize
        border
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="name"
          :title="$t('text.name')"
          min-width="100px"
        />
        <vxe-table-column
          field="code"
          :title="$t('courier.code')"
          min-width="140px"
        />
        <vxe-table-column
          field="description"
          :title="$t('courier.description')"
          min-width="140px"
        />
        <vxe-table-column
          field="carrierCode"
          :title="$t('courier.carrierCode')"
          min-width="100px"
        />
        <vxe-table-column
          field="carrierMethod"
          :title="$t('courier.carrierMethod')"
          min-width="100px"
        />
      </vxe-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="deliverMethodDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 联邦 -->
    <el-dialog
      :title="$t('action.lianbang')"
      :visible.sync="addLianbangDF"
      :close-on-click-modal="false"
      width="50%"
    >
      <el-form
        ref="addLianbangObjForm"
        :model="addLianbangObj"
        label-width="90px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('lianbang.accountNum')"
              :prop="'accountNum'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('lianbang.accountNum')]),
                  trigger: 'blur',
                },
              ]"
              label-width="110px"
            >
              <el-input
                size="small"
                v-model.trim="addLianbangObj.accountNum"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <img
              src="@/assets/fedex.jpg"
              style="width: 80px"
              class="float-left mgr20"
            />
            <div class="float-left">
              <a
                target="_blank"
                href="/normal/contact"
                style="height: 45px; line-height: 45px"
              >
                联系简赢客服
              </a>
            </div>
          </el-col>
        </el-row>
        <fieldset>
          <legend>
            {{ $t("lianbang.shippingAddress") }}
            <span class="font10 orange">全英文填写</span>
          </legend>
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('lianbang.shippingAddress_countryCode')"
                :prop="'shippingAddress.countryCode'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [
                      $t('lianbang.shippingAddress_countryCode'),
                    ]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  size="small"
                  v-model="addLianbangObj.shippingAddress.countryCode"
                  filterable
                  clearable
                  :placeholder="$t('lianbang.shippingAddress_countryCode')"
                >
                  <el-option
                    v-for="country in countries"
                    :key="country"
                    :label="$t('countries.' + country)"
                    :value="country"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('lianbang.shippingAddress_stateOrProvinceCode')"
                :prop="'shippingAddress.stateOrProvinceCode'"
              >
                <el-input
                  size="small"
                  v-model.trim="
                    addLianbangObj.shippingAddress.stateOrProvinceCode
                  "
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('lianbang.shippingAddress_city')"
                :prop="'shippingAddress.city'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [
                      $t('lianbang.shippingAddress_city'),
                    ]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  size="small"
                  v-model.trim="addLianbangObj.shippingAddress.city"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('lianbang.shippingAddress_streetLines')"
                :prop="'shippingAddress._streetLines'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [
                      $t('lianbang.shippingAddress_streetLines'),
                    ]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  size="small"
                  v-model.trim="addLianbangObj.shippingAddress._streetLines"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('lianbang.shippingAddress_postalCode')"
                :prop="'shippingAddress.postalCode'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [
                      $t('lianbang.shippingAddress_postalCode'),
                    ]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  size="small"
                  v-model.trim="addLianbangObj.shippingAddress.postalCode"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </fieldset>
        <fieldset>
          <legend>
            {{ $t("lianbang.contactAndAddress") }}
            <span class="font10 orange">全英文填写</span>
          </legend>
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('lianbang.contactAndAddress_firstName')"
                :prop="'contactAndAddress.contact.personName.firstName'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [
                      $t('lianbang.contactAndAddress_firstName'),
                    ]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  size="small"
                  v-model.trim="
                    addLianbangObj.contactAndAddress.contact.personName
                      .firstName
                  "
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('lianbang.contactAndAddress_lastName')"
                :prop="'contactAndAddress.contact.personName.lastName'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [
                      $t('lianbang.contactAndAddress_lastName'),
                    ]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  size="small"
                  v-model.trim="
                    addLianbangObj.contactAndAddress.contact.personName.lastName
                  "
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('lianbang.contactAndAddress_companyName')"
                :prop="'contactAndAddress.contact.companyName'"
              >
                <el-input
                  size="small"
                  v-model.trim="
                    addLianbangObj.contactAndAddress.contact.companyName
                  "
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('lianbang.contactAndAddress_phoneNumber')"
                :prop="'contactAndAddress.contact.phoneNumber'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [
                      $t('lianbang.contactAndAddress_phoneNumber'),
                    ]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  size="small"
                  v-model.trim="
                    addLianbangObj.contactAndAddress.contact.phoneNumber
                  "
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('lianbang.contactAndAddress_countryCode')"
                :prop="'contactAndAddress.address.countryCode'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [
                      $t('lianbang.contactAndAddress_countryCode'),
                    ]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  size="small"
                  v-model="addLianbangObj.contactAndAddress.address.countryCode"
                  filterable
                  clearable
                  :placeholder="$t('lianbang.contactAndAddress_countryCode')"
                >
                  <el-option
                    v-for="country in countries"
                    :key="country"
                    :label="$t('countries.' + country)"
                    :value="country"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('lianbang.contactAndAddress_stateOrProvinceCode')"
                :prop="'contactAndAddress.address.stateOrProvinceCode'"
              >
                <el-input
                  size="small"
                  v-model.trim="
                    addLianbangObj.contactAndAddress.address.stateOrProvinceCode
                  "
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('lianbang.contactAndAddress_city')"
                :prop="'contactAndAddress.address.city'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [
                      $t('lianbang.contactAndAddress_city'),
                    ]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  size="small"
                  v-model.trim="addLianbangObj.contactAndAddress.address.city"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('lianbang.contactAndAddress_streetLines')"
                :prop="'contactAndAddress.address._streetLines'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [
                      $t('lianbang.contactAndAddress_streetLines'),
                    ]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  size="small"
                  v-model.trim="
                    addLianbangObj.contactAndAddress.address._streetLines
                  "
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('lianbang.contactAndAddress_postalCode')"
                :prop="'contactAndAddress.address.postalCode'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [
                      $t('lianbang.contactAndAddress_postalCode'),
                    ]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  size="small"
                  v-model.trim="
                    addLianbangObj.contactAndAddress.address.postalCode
                  "
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('lianbang.contactAndAddress_emailAddress')"
                :prop="'contactAndAddress.contact.emailAddress'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [
                      $t('lianbang.contactAndAddress_emailAddress'),
                    ]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  size="small"
                  v-model.trim="
                    addLianbangObj.contactAndAddress.contact.emailAddress
                  "
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </fieldset>
        <div class="right">
          <el-checkbox v-model="addLianbangObj.agreementDF">
            <a
              href=" https://files.jianyingkeji.com/public/%E8%81%94%E9%82%A6%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE.pdf"
              target="_blank"
              >同意《最终用户许可协议》</a
            >
          </el-checkbox>
        </div>
        <div style="font-size: 8pt" class="strong center">
          The FedEx service marks are owned by Federal Express Corporation and
          are used by permission.
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="addLianbangDoing"
          size="small"
          @click="addLianbangSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addLianbangDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 编辑 -->
    <el-dialog
      :title="$t('text.edit')"
      :visible.sync="editSumaitongDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form
        ref="editSumaitongObjForm"
        :model="editSumaitongObj"
        label-width="60px"
      >
        <el-form-item
          :label="$t('courier.economyService')"
          :prop="'economyServiceId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('courier.economyService')]),
              trigger: 'blur',
            },
          ]"
          style="margin-bottom: 5px"
        >
          <el-select
            size="small"
            v-model="editSumaitongObj.economyServiceId"
            filterable
            @change="selectEconomyService()"
          >
            <el-option
              v-for="(economyService, index) in economyServices"
              :key="index"
              :label="
                economyService.warehouse_name +
                ' / ' +
                economyService.logistics_service_name
              "
              :value="economyService.logistics_service_id"
            >
              <span style="float: left">{{
                economyService.warehouse_name
              }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                economyService.logistics_service_name
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <div
          class="font10 grey mgl20 mgb10"
          v-if="economyServiceObj != null"
          style="margin-left: 60px"
        >
          {{ economyServiceObj.delivery_address }}
        </div>
        <el-form-item
          :label="$t('courier.standardService')"
          :prop="'standardServiceId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('courier.standardService')]),
              trigger: 'blur',
            },
          ]"
          style="margin-bottom: 5px"
        >
          <el-select
            size="small"
            v-model="editSumaitongObj.standardServiceId"
            filterable
            @change="selectStandardService()"
          >
            <el-option
              v-for="(standardService, index) in standardServices"
              :key="index"
              :label="
                standardService.warehouse_name +
                ' / ' +
                standardService.logistics_service_name
              "
              :value="standardService.logistics_service_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <div
          class="font10 grey mgb10"
          v-if="standardServiceObj != null"
          style="margin-left: 60px"
        >
          {{ standardServiceObj.delivery_address }}
        </div>

        <el-form-item
          :label="$t('courier.premiumService')"
          :prop="'premiumServiceId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('courier.premiumService')]),
              trigger: 'blur',
            },
          ]"
          style="margin-bottom: 5px"
        >
          <el-select
            size="small"
            v-model="editSumaitongObj.premiumServiceId"
            filterable
            @change="selectPremiumService()"
          >
            <el-option
              v-for="(premiumService, index) in premiumServices"
              :key="index"
              :label="
                premiumService.warehouse_name +
                ' / ' +
                premiumService.logistics_service_name
              "
              :value="premiumService.logistics_service_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <div
          class="font10 grey"
          v-if="premiumServiceObj != null"
          style="margin-left: 60px"
        >
          {{ premiumServiceObj.delivery_address }}
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="editSubmitDoing"
          size="small"
          @click="editSumaitongSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editSumaitongDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('text.edit')"
      :visible.sync="editYouzhengDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form
        ref="editYouzhengObjForm"
        :model="editYouzhengObj"
        label-width="130px"
      >
        <el-form-item
          :label="$t('courier.erpKey')"
          :prop="'erpKey'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('courier.erpKey')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editYouzhengObj.erpKey"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('courier.erpPassword')"
          :prop="'erpPassword'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('courier.erpPassword')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editYouzhengObj.erpPassword"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('courier.whCode')"
          :prop="'whCode'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('courier.whCode')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editYouzhengObj.whCode"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('courier.account')"
          :prop="'account'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('courier.account')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="editYouzhengObj.account"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="editSubmitDoing"
          size="small"
          @click="editYouzhengSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editYouzhengDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('action.integration')"
      :close-on-click-modal="false"
      :visible.sync="integrationDF"
      width="50%"
    >
      <div
        class="orange center font10"
        v-if="row && row.courier && !['Jitu'].includes(row.courier.erp)"
      >
        说明：账号和密码不填表示取消集成
      </div>
      <el-form
        ref="integrationForm"
        :model="integrationObj"
        label-width="140px"
      >
        <template
          v-if="
            row && row.courier && !['Dhl', 'Jitu'].includes(row.courier.erp)
          "
        >
          <el-row>
            <el-col :span="12">
              <el-form-item :prop="'erpKey'" :label="$t('courier.erpKey')">
                <el-input size="small" v-model.trim="integrationObj.erpKey" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :prop="'erpPassword'"
                :label="$t('courier.erpPassword')"
              >
                <el-input
                  size="small"
                  v-model.trim="integrationObj.erpPassword"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-if="row && row.courier && row.courier.erp == 'Shunfeng'">
          <el-row>
            <el-col :span="12">
              <el-form-item
                :prop="'aeskey'"
                :label="$t('courier.aeskey')"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('courier.aeskey')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input size="small" v-model.trim="integrationObj.aeskey" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :prop="'apiusername'"
                :label="$t('courier.apiusername')"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('courier.apiusername')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input
                  size="small"
                  v-model.trim="integrationObj.apiusername"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :prop="'account'" :label="$t('courier.accountSF')">
                <el-input size="small" v-model.trim="integrationObj.account" />
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-if="row && row.courier && row.courier.erp == 'Dhl'">
          <fieldset>
            <legend>制单</legend>
            <el-row>
              <el-col :span="12">
                <el-form-item :prop="'erpKey'" :label="$t('courier.erpKeyDhl')">
                  <el-input size="small" v-model.trim="integrationObj.erpKey" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :prop="'erpPassword'"
                  :label="$t('courier.erpPasswordDhl')"
                >
                  <el-input
                    size="small"
                    v-model.trim="integrationObj.erpPassword"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  :prop="'accountNumber'"
                  :label="$t('courier.accountNumber')"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [
                        $t('courier.accountNumber'),
                      ]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    size="small"
                    v-model.trim="integrationObj.accountNumber"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset>
            <legend>申报</legend>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  :prop="'consumerCode'"
                  :label="$t('courier.consumerCodeDhl')"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [
                        $t('courier.consumerCodeDhl'),
                      ]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    size="small"
                    v-model.trim="integrationObj.consumerCode"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :prop="'key'"
                  :label="$t('courier.keyDhl')"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('courier.keyDhl')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input size="small" v-model.trim="integrationObj.key" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  :prop="'businessName'"
                  :label="$t('courier.businessNameDhl')"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [
                        $t('courier.businessNameDhl'),
                      ]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    size="small"
                    v-model.trim="integrationObj.businessName"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :prop="'businessNumber'"
                  :label="$t('courier.businessNumberDhl')"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [
                        $t('courier.businessNumberDhl'),
                      ]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    size="small"
                    v-model.trim="integrationObj.businessNumber"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item :prop="'crCode'" :label="$t('courier.crCodeDhl')">
                  <el-input size="small" v-model.trim="integrationObj.crCode" />
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset>
            <legend>
              无纸化贸易
              <span class="orange font10 float-right">*电子签名不超过100K</span>
            </legend>
          </fieldset>
          <el-row>
            <el-col :span="12">
              <el-form-item
                :prop="'signName'"
                :label="$t('courier.signNameDhl')"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('courier.signNameDhl')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input size="small" v-model.trim="integrationObj.signName" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :prop="'signImage'"
                :label="$t('courier.signImageDhl')"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('courier.signImageDhl')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <upload-single-picture-base-64
                  v-model="integrationObj.signImage"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-if="row && row.courier && row.courier.erp == 'Lianbang'">
          <fieldset>
            <legend>
              ETD 信息<span class="orange font10"
                >发货人签名、公司抬头图片宽高不大于宽700px高50px,不超过100K</span
              >
            </legend>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  :prop="'lianbangSignImage'"
                  :label="$t('courier.lianbangSignImage')"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [
                        $t('courier.lianbangSignImage'),
                      ]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <upload-single-picture-base-64
                    v-model="integrationObj.lianbangSignImage"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :prop="'lianbangLetterHead'"
                  :label="$t('courier.lianbangLetterHead')"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [
                        $t('courier.lianbangLetterHead'),
                      ]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <upload-single-picture-base-64
                    v-model="integrationObj.lianbangLetterHead"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
        </template>
        <template v-if="row && row.courier && row.courier.erp == 'Jitu'">
          <el-row>
            <el-col :span="12">
              <el-form-item
                :prop="'erpKey'"
                :label="$t('courier.JituErpKey')"
                label-width="100px"
              >
                <el-input size="small" v-model.trim="integrationObj.erpKey" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :prop="'erpPassword'"
                :label="$t('courier.JituErpPassword')"
                label-width="100px"
              >
                <el-input
                  size="small"
                  v-model.trim="integrationObj.erpPassword"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :prop="'account'"
                :label="$t('courier.JituAccount')"
                label-width="100px"
              >
                <el-input size="small" v-model.trim="integrationObj.account" />
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="integrationDoing"
          size="small"
          @click="integrationSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="integrationDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('action.dhlDpsProd')"
      :close-on-click-modal="false"
      :visible.sync="dhlDpsProdDF"
      width="30%"
    >
      <el-form
        ref="dhlDpsProdObjForm"
        :model="dhlDpsProdObj"
        label-width="130px"
      >
        <el-form-item
          :prop="'consumerCode'"
          :label="$t('courier.consumerCodeDhl')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('courier.consumerCodeDhl')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="dhlDpsProdObj.consumerCode" />
        </el-form-item>
        <el-form-item
          :prop="'key'"
          :label="$t('courier.keyDhl')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('courier.keyDhl')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="dhlDpsProdObj.key" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="dhlDpsProdSubmitDoing"
          size="small"
          @click="dhlDpsProdSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="dhlDpsProdDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Util from "@/utils";
import Courier from "@/api/courier.js";
import DeliverMethod from "@/api/deliverMethod.js";
import UploadSinglePictureBase64 from "@/components/UploadSinglePictureBase64";

import {
  countries,
  economyServices,
  standardServices,
  premiumServices,
} from "@/utils/enums.js";

export default {
  mixins: [page],
  components: {
    UploadSinglePictureBase64,
  },
  data() {
    var validateCourierId = (rule, value, callback) => {
      const self = this;
      if (value == null) {
        callback(
          new Error(
            self.$t("rules.required", [this.$t("courier.courierAccount")])
          )
        );
        return;
      }
      if (self.courierTenants.find((ct) => ct.courierId == value) != null) {
        callback(new Error(self.$t("rules.exist", [self.$t("menu.couriers")])));
      } else {
        callback();
      }
    };
    return {
      courierTenants: [],

      // 新增
      couriers: [],
      couriersSelect: [],
      validateCourierId: validateCourierId,
      addDF: false,
      addObj: {
        courierId: null,
      },
      // courier: null,
      addDoing: false,
      //
      deliverMethodDF: false,
      deliverMethods: [],
      //联邦对接
      countries: countries,
      addLianbangDF: false,
      addLianbangObj: {
        agreementDF: false,
        accountNum: null,
        shippingAddress: {
          _streetLines: null,
          streetLines: [],
          city: null,
          stateOrProvinceCode: null,
          postalCode: null,
          countryCode: null,
        },
        contactAndAddress: {
          contact: {
            personName: {
              firstName: null,
              lastName: null,
            },
            companyName: null,
            phoneNumber: null,
            emailAddress: null,
          },
          address: {
            _streetLines: null,
            streetLines: [],
            city: null,
            stateOrProvinceCode: null,
            postalCode: null,
            countryCode: null,
          },

          agreementDF: false,
        },
      },
      addLianbangDoing: false,
      //编辑
      economyServices: economyServices,
      standardServices: standardServices,
      premiumServices: premiumServices,
      editSumaitongDF: false,
      editSumaitongObj: {
        id: null,
        economyServiceId: null,
        standardServiceId: null,
        premiumServiceId: null,

        economyServiceJson: null,
        standardServiceJson: null,
        premiumServiceJson: null,
      },
      economyServiceObj: null,
      standardServiceObj: null,
      premiumServiceObj: null,
      editSubmitDoing: false,
      // 编辑邮政
      row: null,
      editYouzhengDF: false,
      editYouzhengObj: {
        erpKey: null, //"协议大客户号",
        erpPassword: null, //"密钥",
        mailType: null, //"erp标识",
        whCode: null, //"揽收机构号",
        account: null, // ‘分账号’
      },
      // 集成
      integrationDF: false,
      integrationObj: {
        id: null,
        erpKey: null,
        erpPassword: null,
        aeskey: null,
        apiusername: null,
        accountNumber: null,
        consumerCode: null,
        key: null,
        account: null,
        crCode: null,
        businessNumber: null,
        businessName: null,
        signName: null,
        signImage: null,
        businessName: null,
        lianbangSignImage: null,
        lianbangLetterHead: null,
      },
      row: null,
      integrationDoing: false,
      //
      dhlDpsProdDF: false,
      dhlDpsProdObj: {
        consumerCode: null,
        key: null,
      },
      dhlDpsProdSubmitDoing: false,
    };
  },
  created() {
    const self = this;
    self.loadData();
  },
  methods: {
    dhlDpsProd(row) {
      const self = this;
      self.row = row;
      self.dhlDpsProdObj.consumerCode = row.consumerCode;
      self.dhlDpsProdObj.key = row.key;
      self.dhlDpsProdDF = true;
    },
    dhlDpsProdSubmit() {
      const self = this;
      this.$refs.dhlDpsProdObjForm.validate((valid) => {
        if (valid) {
          self.dhlDpsProdSubmitDoing = true;
          Courier.dhlDpsOrod(self.row.id, self.dhlDpsProdObj).then(function (
            res
          ) {
            self.dhlDpsProdSubmitDoing = false;
            self.dhlDpsProdDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.dhlDpsProdSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    //
    integration(row) {
      const self = this;
      self.row = row;
      if (row.courier.erp == "AmazonShip") {
        // self.$router.push({ name: "perferenceLmsCouriersAmazonsShipShow" });
        Courier.amazonAuth().then(function (res) {
          if (res.status == 200) {
            window.open(res.data);
          } else {
            self.sysError();
          }
        });
        return;
      }
      self.integrationObj.id = row.id;
      self.integrationObj.erpKey = row.erpKey;
      self.integrationObj.erpPassword = row.erpPassword;
      self.integrationObj.aeskey = row.aeskey;
      self.integrationObj.apiusername = row.apiusername;
      self.integrationObj.accountNumber = row.accountNumber;
      self.integrationObj.consumerCode = row.consumerCode;
      self.integrationObj.key = row.key;
      self.integrationObj.account = row.account;
      self.integrationObj.crCode = row.crCode;
      self.integrationObj.businessNumber = row.businessNumber;
      self.integrationObj.businessName = row.businessName;
      self.integrationObj.signName = row.signName;
      self.integrationObj.businessName = row.businessName;
      self.integrationObj.signImage = row.signImage;
      self.integrationObj.lianbangSignImage = row.lianbangSignImage;
      self.integrationObj.lianbangLetterHead = row.lianbangLetterHead;
      self.integrationDF = true;
    },

    integrationSubmit() {
      const self = this;
      console.log("==", self.integrationObj);
      this.$refs.integrationForm.validate((valid) => {
        if (valid) {
          if (
            self.row &&
            self.row.courier &&
            self.row.courier.erp == "Lianbang"
          ) {
            if (
              (self.integrationObj.lianbangSignImage ?? "") == "" ||
              (self.integrationObj.lianbangLetterHead ?? "") == ""
            ) {
              self.$message({
                message: "请上传ETD信息",
                type: "warning",
              });
            }
            self.integrationDoing = true;
            axios
              .all([
                Courier.authorise(self.integrationObj),
                Courier.uploadLianbangSignImage({
                  file: self.integrationObj.lianbangSignImage,
                }),
                Courier.uploadLianbangLetterHead({
                  file: self.integrationObj.lianbangLetterHead,
                }),
              ])
              .then(
                axios.spread(function (
                  authoriseRes,
                  uploadLianbangSignImageRes,
                  uploadLianbangLetterHeadRes
                ) {
                  if (
                    authoriseRes.status == 200 &&
                    uploadLianbangSignImageRes.status == 200 &&
                    uploadLianbangLetterHeadRes.data.type == "success" &&
                    uploadLianbangLetterHeadRes.status == 200 &&
                    uploadLianbangLetterHeadRes.data.type == "success"
                  ) {
                    self.$message({
                      message: self.$t("prompt.integrationSuccess"),
                      type: "success",
                    });
                    self.loadData();
                    self.integrationDoing = false;
                    self.integrationDF = false;
                    return;
                  }
                  let message = "";
                  if (authoriseRes.status == 200) {
                    message = message + "账号、密钥集成成功！";
                  } else {
                    message = message + "账号、密钥集成失败！";
                  }
                  if (
                    uploadLianbangSignImageRes.status == 200 &&
                    uploadLianbangLetterHeadRes.data
                  ) {
                    let signImageMessage =
                      "<br/>发货人签名:" +
                      uploadLianbangSignImageRes.data.message;
                    message = message + signImageMessage;
                  }
                  if (
                    uploadLianbangLetterHeadRes.status == 200 &&
                    uploadLianbangLetterHeadRes.data
                  ) {
                    let letterHeadMessage =
                      "<br/>公司抬头:" +
                      uploadLianbangLetterHeadRes.data.message;
                    message = message + letterHeadMessage;
                  }
                  self.$message({
                    dangerouslyUseHTMLString: true,
                    message: message,
                    type: "warning",
                  });
                  self.loadData();
                  self.integrationDoing = false;
                  self.integrationDF = false;
                  return;
                })
              );
          } else {
            self.integrationDoing = true;
            Courier.authorise(self.integrationObj).then(function (res) {
              self.integrationDoing = false;
              self.integrationDF = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.integrationSuccess"),
                  type: "success",
                });
                self.loadData();
              } else {
                self.sysError();
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    //
    printPck(row) {
      const self = this;
      Courier.printPick(row.id).then(function (res) {
        if (res.status == 200) {
          self.$message({
            message: self.$t("prompt.setSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    cancelPrintPck(row) {
      const self = this;
      Courier.cancelPrintPick(row.id).then(function (res) {
        if (res.status == 200) {
          self.$message({
            message: self.$t("prompt.cancelSetSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 编辑邮政
    editYouzheng(row) {
      const self = this;
      self.row = row;
      self.editYouzhengObj.erpKey = row.erpKey;
      self.editYouzhengObj.erpPassword = row.erpPassword;
      self.editYouzhengObj.mailType = row.mailType;
      self.editYouzhengObj.whCode = row.whCode;
      self.editYouzhengObj.account = row.account;
      self.editSubmitDoing = false;
      self.editYouzhengDF = true;
    },
    editYouzhengSubmit() {
      const self = this;
      self.$refs.editYouzhengObjForm.validate((valid) => {
        if (valid) {
          self.editSubmitDoing = true;
          Courier.youzhengAuth(self.row.id, self.editYouzhengObj).then(
            function (res) {
              self.editSubmitDoing = false;
              self.editYouzhengDF = false;
              if (res.status == 200) {
                self.$message({
                  message: self.$t("prompt.editSuccess"),
                  type: "warning",
                });
                self.loadData();
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },

    //编辑速卖通
    editSumaitong(row) {
      const self = this;
      self.editSumaitongObj.id = row.id;
      self.editSumaitongObj.economyServiceId =
        row.economyServiceJson != null
          ? JSON.parse(row.economyServiceJson).logistics_service_id
          : null;
      self.editSumaitongObj.standardServiceId =
        row.standardServiceJson != null
          ? JSON.parse(row.standardServiceJson).logistics_service_id
          : null;
      self.editSumaitongObj.premiumServiceId =
        row.premiumServiceJson != null
          ? JSON.parse(row.premiumServiceJson).logistics_service_id
          : null;
      self.selectStandardService();
      self.selectEconomyService();
      self.selectPremiumService();
      self.editSumaitongObj.economyServiceJson = null;
      self.editSumaitongObj.standardServiceJson = null;
      self.editSumaitongObj.premiumServiceJson = null;
      self.editSubmitDoing = false;
      self.editSumaitongDF = true;
    },
    selectStandardService() {
      const self = this;
      if (self.editSumaitongObj.standardServiceId != null) {
        self.standardServiceObj = self.standardServices.find(
          (s) =>
            s.logistics_service_id == self.editSumaitongObj.standardServiceId
        );
      }
    },
    selectEconomyService() {
      const self = this;
      if (self.editSumaitongObj.economyServiceId != null) {
        self.economyServiceObj = self.economyServices.find(
          (s) =>
            s.logistics_service_id == self.editSumaitongObj.economyServiceId
        );
      }
    },
    selectPremiumService() {
      const self = this;
      if (self.editSumaitongObj.premiumServiceId != null) {
        self.premiumServiceObj = self.premiumServices.find(
          (s) =>
            s.logistics_service_id == self.editSumaitongObj.premiumServiceId
        );
      }
    },
    editSumaitongSubmit() {
      const self = this;
      self.$refs.editSumaitongObjForm.validate((valid) => {
        if (valid) {
          self.editSumaitongObj.economyServiceJson = JSON.stringify(
            self.economyServiceObj
          );
          self.editSumaitongObj.standardServiceJson = JSON.stringify(
            self.standardServiceObj
          );
          self.editSumaitongObj.premiumServiceJson = JSON.stringify(
            self.premiumServiceObj
          );
          self.editSubmitDoing = true;
          Courier.aliexpressService(self.editSumaitongObj).then(function (res) {
            self.editSubmitDoing = false;
            self.editSumaitongDF = false;
            if (res.status == 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "warning",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    //
    showLianBangCompute() {
      let courierIds = this.courierTenants.map((c) => c.courierId);
      return !courierIds.includes(67);
    },
    addLianbang() {
      const self = this;
      self.addLianbangObj.agreementDF = false;
      // self.addLianbangObj.shippingAddress._streetLines =
      //   self.Permit.currentTenant().address;
      // self.addLianbangObj.shippingAddress.city =
      //   self.Permit.currentTenant().city;
      // self.addLianbangObj.shippingAddress.stateOrProvinceCode = null;
      // self.addLianbangObj.shippingAddress.postalCode = null;
      // self.addLianbangObj.shippingAddress.countryCode =
      //   self.Permit.currentTenant().country;

      // self.addLianbangObj.contactAndAddress.contact.personName.firstName =
      //   self.Permit.currentUser().name;
      // self.addLianbangObj.contactAndAddress.contact.personName.lastName =
      //   self.Permit.currentUser().name;
      // self.addLianbangObj.contactAndAddress.contact.companyName =
      //   self.Permit.currentTenant().name;
      // self.addLianbangObj.contactAndAddress.contact.phoneNumber =
      //   self.Permit.currentUser().phone;
      // self.addLianbangObj.contactAndAddress.contact.emailAddress = null;
      // self.addLianbangObj.contactAndAddress.address._streetLines =
      //   self.Permit.currentTenant().address;
      // self.addLianbangObj.contactAndAddress.address.city =
      //   self.Permit.currentTenant().city;
      // self.addLianbangObj.contactAndAddress.address.stateOrProvinceCode = null;

      // self.addLianbangObj.contactAndAddress.address.postalCode = null;
      // self.addLianbangObj.contactAndAddress.address.countryCode =
      //   self.Permit.currentTenant().country;
      self.addLianbangObj.shippingAddress._streetLines = null;
      self.addLianbangObj.shippingAddress.streetLines = null;
      self.addLianbangObj.shippingAddress.city = null;
      self.addLianbangObj.shippingAddress.stateOrProvinceCode = null;
      self.addLianbangObj.shippingAddress.postalCode = null;
      self.addLianbangObj.shippingAddress.countryCode = null;

      self.addLianbangObj.contactAndAddress.contact.personName.firstName = null;
      self.addLianbangObj.contactAndAddress.contact.personName.lastName = null;
      self.addLianbangObj.contactAndAddress.contact.companyName = null;
      self.addLianbangObj.contactAndAddress.contact.phoneNumber = null;
      self.addLianbangObj.contactAndAddress.contact.emailAddress = null;

      self.addLianbangObj.contactAndAddress.address._streetLines = null;
      self.addLianbangObj.contactAndAddress.address.streetLines = null;
      self.addLianbangObj.contactAndAddress.address.city = null;
      self.addLianbangObj.contactAndAddress.address.stateOrProvinceCode = null;
      self.addLianbangObj.contactAndAddress.address.postalCode = null;
      self.addLianbangObj.contactAndAddress.address.countryCode = null;
      self.addLianbangDF = true;
    },
    addLianbangSubmit() {
      const self = this;
      self.$refs.addLianbangObjForm.validate((valid) => {
        if (valid) {
          if (self.addLianbangObj.agreementDF == false) {
            self.$message({
              message: "请勾选最终用户许可协议",
              type: "warning",
            });
            return;
          }
          self.addLianbangObj.shippingAddress.streetLines = [
            self.addLianbangObj.shippingAddress._streetLines,
          ];
          self.addLianbangObj.contactAndAddress.address.streetLines = [
            self.addLianbangObj.contactAndAddress.address._streetLines,
          ];
          self.addLianbangDoing = true;
          Courier.fedex(self.addLianbangObj).then(function (res) {
            self.addLianbangDoing = false;
            self.addLianbangDF = false;
            if (res.status == 200) {
              self.sysResult(res.data);
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    //
    deliverMethod(row) {
      const self = this;
      DeliverMethod.findByCourierId(row.courier.id).then(function (res) {
        if (res.status === 200) {
          self.deliverMethods = res.data;
          if (self.deliverMethods.length !== 0) {
            self.deliverMethodDF = true;
          } else {
            self.$message({
              message: self.$t("prompt.noDeliverMethod"),
              type: "warning",
            });
          }
        } else {
          self.sysError();
        }
      });
    },
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Courier.deleteCourierTenant(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    add() {
      const self = this;
      self.addObj.courierId = null;
      self.saveDoing = false;
      Courier.all().then(function (res) {
        if (res.status == 200) {
          self.couriers = res.data;
          self.couriersSelect = [
            {
              label: "简赢对接",
              options: self.couriers.filter(
                (c) => c.erp != null && c.erp != ""
              ),
            },
            {
              label: "未对接",
              options: self.couriers.filter(
                (c) => c.erp == null || c.erp == ""
              ),
            },
          ];
          self.addDF = true;
        } else {
          self.sysError();
        }
      });
    },

    addSubmit() {
      const self = this;
      this.$refs.addObjForm.validate((valid) => {
        if (valid) {
          self.saveDoing = true;
          const obj = {
            courierId: self.addObj.courierId,
            courier: self.couriers.find((c) => c.id == self.addObj.courierId),
            erpKey: null,
            erpPassword: null,
          };
          Courier.createCourierTenant(obj).then(function (res) {
            self.saveDoing = false;
            self.addDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    loadData() {
      const self = this;
      self.loadingStart();
      Courier.findCourierTenantByTenantId().then(function (res) {
        if (res.status === 200) {
          self.courierTenants = res.data;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
  },
};
</script>
<style scoped>
</style>